import React from 'react';
import { roundFloat } from 'src/core/utils/formater';
import { Button, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';

export const customSummary = [
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'left', word: 'Нийт:' },
  { align: 'right', value: 'huuli_7_1_1' },
  { align: 'right', value: 'huuli_7_1_2' },
  { align: 'right', value: '' },
  { align: 'right', value: 'huuli_7_1_6' },
  { align: 'right', value: 'niit_1_2_3' },
  { align: 'right', value: '' },
  { align: 'right', value: 'emd_ndsh_dun_huuli_7_1_1' },
  { align: 'right', value: 'emd_ndsh_dun_huuli_7_1_6' },
  { align: 'right', value: 'huuli_7_1_4_7' },
  { align: 'right', value: '' },
  { align: 'right', value: 'orlogo' },
  { align: 'right', value: 'niit_tatvar_nogduulah_orlogo' },
  { align: 'right', value: 'shatlal' },
];

export const MulticustomSummary = [
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'left', word: 'Нийт:' },
  { align: 'right', value: 'huuli_7_1_1' },
  { align: 'right', value: 'huuli_7_1_2' },
  { align: 'right', value: 'huuli_7_1_6' },
  { align: 'right', value: 'niit_1_2_3' },
  { align: 'right', value: '' },
  { align: 'right', value: 'emd_ndsh_dun_huuli_7_1_1' },
  { align: 'right', value: 'emd_ndsh_dun_huuli_7_1_6' },
  { align: 'right', value: 'huuli_7_1_4_7' },
  { align: 'right', value: '' },
  { align: 'right', value: 'orlogo' },
  { align: 'right', value: 'niit_tatvar_nogduulah_orlogo' },
  { align: 'right', value: 'shatlal' },
];
export const columns = ({ showEditModal, shouldRenderEditColumn }) => {
  const cols = [
    {
      title: 'Татвар төлөгчийн дугаар',
      dataIndex: 'ttd',
      align: 'center',
      width: 150,
      fixed: 'left',
    },
    {
      title: 'Овог',
      dataIndex: 'ovog',
      align: 'right',
      width: 150,
      className: 'cell-left-border',
    },
    {
      title: 'Нэр',
      dataIndex: 'ner',
      align: 'right',
      width: 150,
    },
    {
      title: 'Хуулийн 7.1.1',
      dataIndex: 'huuli_7_1_1',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хуулийн 7.1.2',
      dataIndex: 'huuli_7_1_2',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хуулийн 7.1.6',
      dataIndex: 'huuli_7_1_6',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Нийт (1+2+3)',
      dataIndex: 'niit_1_2_3',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'ЭМД, НДШ Хувь',
      dataIndex: 'emd_ndsh_huvi',
      align: 'right',
      width: 150,
      render: (_) => `${_}%`,
    },
    {
      title: 'ЭМД, НДШ Дүн (Хуулийн 7.1.1)',
      dataIndex: 'emd_ndsh_dun_huuli_7_1_1',
      align: 'right',
      width: 180,
      render: (_) => roundFloat(_),
    },
    {
      title: 'ЭМД, НДШ Дүн (Хуулийн 7.1.6)',
      dataIndex: 'emd_ndsh_dun_huuli_7_1_6',
      align: 'right',
      width: 180,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хуулийн 7.1-д заасан орлогод татвар ногдуулах орлого (4-6-7)',
      dataIndex: 'huuli_7_1_4_7',
      align: 'right',
      width: 180,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Орлогын төрөл',
      dataIndex: 'orlogon_turul',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Орлого',
      dataIndex: 'orlogo',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Нийт татвар ногдуулах орлого',
      dataIndex: 'niit_tatvar_nogduulah_orlogo',
      align: 'right',
      width: 180,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Шатлал',
      dataIndex: 'shatlal',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
  ];

  if (shouldRenderEditColumn) {
    const editColumn = {
      title: '',
      dataIndex: 'edit_huuli_7_1_2',
      align: 'center',
      width: 50,
      render: (_, row) => (
        <Tooltip title="Засварлах">
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => showEditModal(row)}
          />
        </Tooltip>
      ),
    };

    // Insert after the huuli_7_1_2 column (index 4)
    cols.splice(5, 0, editColumn); // inserts at position 5
  }

  return cols;
};
